// extracted by mini-css-extract-plugin
export var primitiveLabel = "_uz-0";